module.exports = __webpack_public_path__ + "static/media/freelancer.ef8e1ddb.svg";